import type { IconTypes } from "solid-icons";
import { splitProps } from "solid-js";

/**
 * Lucide `panel-right` variant with the right panel filled in.
 * Used to indicate an active/pinned side panel state.
 * Based on Lucide Icons (ISC License, lucide-icons).
 */
export const LuPanelRightFilled: IconTypes = (props) => {
  const [icon, rest] = splitProps(props, ["size", "color", "title", "style"]);

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden={!icon.title}
      {...rest}
      color={icon.color || "currentColor"}
      height={icon.size || "1em"}
      width={icon.size || "1em"}
      style={{
        ...(typeof icon.style === "object" && icon.style ? icon.style : {}),
        overflow: "visible",
      }}
    >
      {icon.title ? <title>{icon.title}</title> : null}
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <rect x="15" y="3" width="6" height="18" rx="0" fill="currentColor" stroke="none" />
      <rect width="18" height="18" x="3" y="3" rx="2" fill="none" />
    </svg>
  );
};
